import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Star, MapPin, Globe2 } from "lucide-react";

const SPECS = [
  { key: "", label: "All experts" },
  { key: "psychiatrist", label: "Psychiatrist" },
  { key: "neuro_cognitive", label: "Neuro / Cognitive" },
  { key: "adjunctive", label: "Adjunctive therapist" },
];

export default function Experts() {
  const [spec, setSpec] = useState("");
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get(`/experts${spec ? `?specialization=${spec}` : ""}`).then((r) => setList(r.data));
  }, [spec]);

  return (
    <div className="space-y-6" data-testid="experts-page">
      <div>
        <span className="uppercase-label">Clinical Experts</span>
        <h1 className="font-display text-3xl mt-2">Verified specialists</h1>
        <p className="text-[color:var(--mano-ink-soft)] mt-2 max-w-2xl">
          Every expert is manually reviewed by our team before being listed.
        </p>
      </div>

      <div className="flex gap-2 flex-wrap">
        {SPECS.map((s) => (
          <button
            key={s.key || "all"}
            onClick={() => setSpec(s.key)}
            data-testid={`filter-${s.key || "all"}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
              spec === s.key
                ? "bg-[color:var(--mano-primary)] text-white border-[color:var(--mano-primary)]"
                : "bg-white border-[color:var(--mano-border)] hover:bg-[color:var(--mano-border)]/40"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {list.map((e) => (
          <Link
            key={e.id}
            to={`/experts/${e.id}`}
            data-testid={`expert-card-${e.id}`}
            className="flex gap-4 rounded-2xl border border-[color:var(--mano-border)] bg-white p-5 hover:border-[color:var(--mano-primary)] transition-colors"
          >
            <img src={e.avatar} alt={e.name} className="h-20 w-20 rounded-2xl object-cover shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-display text-lg truncate">{e.name}</div>
              <div className="text-sm text-[color:var(--mano-ink-soft)] truncate">{e.credentials}</div>
              <div className="mt-2 flex flex-wrap gap-2 text-xs text-[color:var(--mano-ink-soft)]">
                <span className="inline-flex items-center gap-1"><MapPin size={12} />{e.affiliation}</span>
                <span className="inline-flex items-center gap-1"><Globe2 size={12} />{(e.languages || []).join(", ")}</span>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <span className="inline-flex items-center gap-1 text-xs uppercase-label">
                  <Star size={12} className="text-[color:var(--mano-mild)]" /> Approved
                </span>
                <span className="text-sm font-semibold text-[color:var(--mano-primary)]">₹{e.session_fee_inr}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
